// src/components/portfolio/add-asset/components/SearchModes.js
import React, { useState } from 'react';
import { Building2, Currency, Landmark, Globe, ChevronDown , FolderOpen} from 'lucide-react';

const SearchModes = ({ searchMode, onModeChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const modes = [
    { 
      id: 'local', 
      label: 'Borsa İstanbul',
      icon: Building2,
      description: 'BIST hisse senetleri'
    },
    { 
      id: 'fund', 
      label: 'TEFAS',
      icon: Landmark,
      description: 'Yatırım fonları'
    },
    { 
      id: 'currency', 
      label: 'Döviz',
      icon: Currency,
      description: 'Para birimleri'
    },
    { 
      id: 'api', 
      label: 'Global',
      icon: Globe,
      description: 'Yabancı hisse ve ETF'
    },
    { 
      id: 'portfolio', 
      label: 'Portföyden',
      icon: FolderOpen,
      description: 'Mevcut portföy varlıkları'
    },
  ];

  const selectedMode = modes.find(mode => mode.id === searchMode);

  return (
    <div className="relative mb-4">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-3 bg-white dark:bg-gray-800 border 
                 border-gray-300 dark:border-gray-700 rounded-lg hover:bg-gray-50 
                 dark:hover:bg-gray-700 transition-colors"
      >
        <div className="flex items-center gap-2">
          {selectedMode && (
            <>
              <selectedMode.icon className="w-5 h-5" />
              <span className="font-medium">{selectedMode.label}</span>
            </>
          )}
        </div>
        <ChevronDown className={`w-5 h-5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white dark:bg-gray-800 border 
                      border-gray-300 dark:border-gray-700 rounded-lg shadow-lg">
          {modes.map((mode) => (
            <button
              key={mode.id}
              onClick={() => {
                onModeChange(mode.id);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-3 p-3 hover:bg-gray-50 
                        dark:hover:bg-gray-700 transition-colors
                        ${searchMode === mode.id ? 'bg-blue-50 dark:bg-blue-900/30' : ''}`}
            >
              <mode.icon className="w-5 h-5" />
              <div className="text-left">
                <div className="font-medium">{mode.label}</div>
                <div className="text-sm text-gray-500 dark:text-gray-400">
                  {mode.description}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchModes;